import React from 'react'
import {
    Show,
    SimpleShowLayout,
    TextField,
    NumberField
} from 'react-admin'

import { PermisoField } from '../Permiso'


export const PermisoShow = props => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <NumberField source="user" />
            <TextField source="empresa" />
            <TextField source="encargado" />
            <PermisoField source="permissions" label="Permisos"/>
        </SimpleShowLayout>
    </Show>
);
